import { Sites } from '@ps/platform-message-framework/common/Sites';
import { Translation } from '@ps/web-shared-components';
import React from 'react';
import { useSelector } from 'react-redux';

import PhoneVerification from '@swf/components/PhoneVerification/PhoneVerification';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import { CashierFlowType } from '../../../../types/Cashier';
import Container from '../../../Container/Container';
import useRmfFirstScreen from '../../hooks/useRmfFirstScreen';

import {
  TXTCLI_Verify_your_phone_number,
  TXTWCL_Mobile_Number_Verification
} from './RMFPhoneVerification.messages.json';
import styles from './RMFPhoneVerification.scss';

const RMFPhoneVerification: React.FC = () => {
  const isFirstScreen = useRmfFirstScreen();
  const isDE = useSelector(select.cms.getSiteId) === Sites.DE;
  const isUS = useSelector(select.cms.isSiteUS);
  const isSiteSpecific = isDE || isUS;
  const showVerifyLater = !isSiteSpecific;
  const {
    data: { cashierFlow }
  } = useWizardContext();
  const showBackButton = !isFirstScreen || cashierFlow === CashierFlowType.FirstDeposit;

  return (
    <Container
      page={RMFPhoneVerification}
      headerProps={{
        title: <Translation {...TXTWCL_Mobile_Number_Verification} />,
        buttons: { back: showBackButton }
      }}
      pageClassName={styles.validationPage}
      pageTopTitle={<Translation {...TXTCLI_Verify_your_phone_number} />}
    >
      <PhoneVerification.ValidateCode
        first
        showVerifyLater={showVerifyLater}
        isSiteSpecific={isSiteSpecific}
      />
    </Container>
  );
};

RMFPhoneVerification.displayName = 'RMFPhoneVerification';

export default RMFPhoneVerification;
